<script setup>
import {computed, ref} from "vue";

const props = defineProps({
  items: {
    type: Array
  },
  model: {
    type: Object,
    required: true
  },
});
const searchHistory = ref([]);
const searchAction = computed(() => {
  return `/${props.locale}/search`;
});

const query = ref("");
function handleSearch() {
  const searchTerm = query.value.trim();
  if (!searchTerm) return;

  const newHistory = [
    searchTerm,
    ...searchHistory.value.filter(item => item !== searchTerm)
  ].slice(0, 5);

  searchHistory.value = newHistory;
  localStorage.setItem('search_history', JSON.stringify(newHistory));


  window.location.href = `${searchAction.value}?q=${encodeURIComponent(searchTerm)}`;
}
function isProductMenu(item) {
  return item.class === 'products-menu' || item.label.toLowerCase().includes('produto');
}
</script>
<template>
  <nav class="menu-container">
    <div class="nav-rural" v-if="model.label === 'Mobilidade Rural'">
      <div class="search-mobile">
        <form :action="searchAction" method="GET" class="search-input">
          <input
            type="text"
            v-model="query"
            ref="inputSearchFocus"
            @keyup.enter="handleSearch"
            placeholder="O que procura?">
        </form>
      </div>
      <ul class="nav-list">
        <li v-for="item in items" :key="item.id">
          <div v-if="(item.childs && item.childs.length > 0) || isProductMenu(item)" class="has-submenu">
            <input type="checkbox" :id="'submenu-' + item.id" class="toggle-input submenu-input">

            <label :for="'submenu-' + item.id" class="item-label">
              {{ item.label }}
              <span class="arrow"></span>
            </label>
            <ul class="submenu-list">
              <template v-if="isProductMenu(item)">
                <li v-for="col in model.paginatedProducts?.products" :key="col.id" class="mega-column">
                  <a :href="col.slug" :class="col.class">
                    <p>{{ col.name }} <span>{{ col.reference }}</span> {{ col.label_list }}</p>
                  </a>
                </li>
              </template>
              <template v-else>
                <li v-for="child in item.childs" :key="child.id">
                  <a :href="child.link" :class="child.class">{{ child.label }}</a>
                </li>
              </template>
            </ul>
          </div>
          <div v-else>
            <a :href="item.link" :class="item.class">{{ item.label }}</a>
          </div>
        </li>
      </ul>
    </div>
    <div class="nav-urbana" v-else-if="model.label === 'Mobilidade Urbana'">
      <div class="search-mobile">
        <form :action="searchAction" method="GET" class="search-input">
          <input
            type="text"
            v-model="query"
            ref="inputSearchFocus"
            @keyup.enter="handleSearch"
            placeholder="O que procura?">
        </form>
      </div>
      <ul class="nav-list">
        <li v-for="item in items" :key="item.id">
          <div v-if="(item.childs && item.childs.length > 0) || isProductMenu(item)" class="has-submenu">
            <input type="checkbox" :id="'submenu-' + item.id" class="toggle-input submenu-input">
            <label :for="'submenu-' + item.id" class="item-label">
              {{ item.label }}
              <span class="arrow"></span>
            </label>
            <ul class="submenu-list">
              <template v-if="isProductMenu(item)">
                <li v-for="col in model.paginatedProducts?.products" :key="col.id" class="mega-column">
                  <div v-for="variant in col.variationProducts">
                    <a :href="variant.slug" :class="variant.class">
                      <p>{{ variant.name }}</p>
                      <span v-if="variant.reference"> {{ variant.reference }}</span>
                    </a>
                  </div>
                </li>
              </template>

              <template v-else>
                <li v-for="child in item.childs" :key="child.id">
                  <a :href="child.link" :class="child.class">{{ child.label }}</a>
                </li>
              </template>

            </ul>
          </div>

          <div v-else>
            <a :href="item.link" :class="item.class">{{ item.label }}</a>
          </div>

        </li>
      </ul>
    </div>


  </nav>
</template>

<style scoped>


</style>
